<div class="activation">


  <div *ngIf="loading.isLoading; else loaded">
    <app-loading [loadingText]="loading.message"></app-loading>
  </div>


  <ng-template #loaded>

    <div *ngIf="!loading.isLoading && activated" >

      <div>
        <i class="icon check circle"></i>
      </div>

      <div class="title">
        Your account has been successfully activated.
      </div>
      <div class="message">
        Redirecting you to your course list...
      </div>

    </div>

    <div *ngIf="!loading.isLoading && !activated" >

      <div>
        <i class="icon exclamation triangle"></i>
      </div>

      <div class="title">
        Activation failed.
      </div>

      <div class="message">
        The activation token is invalid or this account has already been activated. Please <a
          [routerLink]="['/auth/login']">login</a> if you have your
        password, or reset your password <a [routerLink]="['/auth/password/forgot']">here</a>.
      </div>

    </div>

  </ng-template>


</div>